import React, { useEffect, useState } from "react";
import {
  AutocompleteInput,
  DateInput,
  FunctionField,
  NumberInput,
  ReferenceInput,
  required,
  SimpleForm,
  useGetOne,
  minValue,
} from "react-admin";
import { useNavigate, useParams } from "react-router-dom";
import {
  useGetBoardSlot,
  useGetSlot,
  useRemoveSlot,
  useSaveSlot,
} from "./RefreshMachineStatus";
import {
  deleteDoc,
  deleteField,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import {
  Box,
  Button,
  CardActions,
  CardContent,
  CardHeader,
  FormControlLabel,
  Grid,
  IconButton,
  Switch,
  Tooltip,
} from "@material-ui/core";
import ProductForm from "./ProductForm";
import _extendLayout from "../../layout/_extendLayout";
import DeleteIcon from "@material-ui/icons/Delete";
import { renderExpiryDate } from "../Employee/ValidateCSV";
import { toast } from "react-toastify";
import { FormProvider, useForm } from "react-hook-form";
const getSlotNum = (machineSlot) => {
  const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const GRID_COL_NUM = 12;
  const row = parseInt(machineSlot / GRID_COL_NUM);
  const column = machineSlot % GRID_COL_NUM;
  if (column === 0) return `${ALPHABET[row - 1]}${column + 12}`;
  return `${ALPHABET[row]}${column}`;
};

const quantityExceedCapacity = (msg) => (value, values) => {
  const { maxCapacity } = values;
  if (value > maxCapacity) {
    return msg || "Invalid";
  }
};

const SlotItemBoardEdit = () => {
  const { machineId, slotId, boardId } = useParams();
  const slotLabel = getSlotNum(slotId);
  const { data: machineRecord, loaded: machineLoaded } = useGetOne("machines", {
    id: machineId,
  });
  const { data: slotRecord, loaded: slotLoaded } = useGetSlot(
    machineId,
    slotId,
  );
  const { data: masterSchemaSlotData, loaded: masterSchemaLoaded } =
    useGetBoardSlot(machineId, boardId, slotId);
  const { saving, save } = useSaveSlot();
  const { removing, remove } = useRemoveSlot(machineId, slotId);
  const isCreate = slotRecord ? false : true;
  //const [formValues, setFormValues] = useState(null);
  let dataToShow = null;
  dataToShow = isCreate ? masterSchemaSlotData : slotRecord;
  const [dropSensor, setDropSensor] = useState(false);
  const [error, setError] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [formKey, setFormKey] = useState(Date.now());
  const [mroAccess, setMROAccess] = useState([]);
  const [productRecord, setProductRecord] = useState(null);
  const [dirtyFields, setDirtyFields] = useState({});
  const [modified, setModified] = useState(false);
  // const [lockValues, setLockValues] = useState(null);
  const productForm = useForm();
  const navigate = useNavigate();
  const productFormValues = productForm.getValues();
  const getCalculatedItemNumber = () => {
    const calculated = parseInt(slotId);
    return calculated;
    //  return calculated === 0 ? parseInt(slotId) : calculated;
  };

  const getItemNumber = () => {
    if (
      slotRecord?.itemNumber !== undefined &&
      slotRecord?.itemNumber !== null
    ) {
      return slotRecord.itemNumber;
    }

    return getCalculatedItemNumber();
  };
  useEffect(() => {
    if (dataToShow) {
      setDropSensor(dataToShow.dropSensor ?? false);
      setError(dataToShow.error ?? false);
      setSelectedProductId(dataToShow?.product?.id ?? null);
      setFormKey(Date.now());
    }
  }, [dataToShow]);
  const onSubmit = async (datas) => {
    const currentMachineMode = machineRecord?.machineMode;
    const boardData = await getAddressByBoardId();
    let productObj = {
      id: datas.product.id,
      name: productRecord.name,
      category: productRecord.category,
      description: productRecord.description ?? "",
      image: {
        src: productRecord.image.src ?? "",
      },
      mroAccessGroup: mroAccess,
      // priceCash: productFormValues.product?.priceCash ?? 0,
      //   priceCredit: productFormValues?.priceCredit ?? 0,
    };

    let slotObj = {
      dropSensor: dropSensor ?? false,
      error: error ?? false,
      itemNumber: datas.itemNumber,
      maxCapacity: datas.maxCapacity,
      minCapacity: datas.minCapacity,
      product: productObj,
      totalQuantity: datas.totalQuantity,
      expiryDate: datas.expiryDate
        ? Timestamp.fromDate(
            datas.expiryDate instanceof Date
              ? datas.expiryDate
              : datas.expiryDate.toDate
                ? datas.expiryDate.toDate()
                : new Date(datas.expiryDate),
          )
        : null,
      type: boardData.type ?? 0,
      machineAddress: boardData.address ?? 0,
      machineSlot: parseInt(slotId),
    };
    if (currentMachineMode === "mro") {
      productObj.priceCredit = productFormValues.product?.priceCredit ?? 0;
    } else {
      productObj.priceCash = productFormValues.product?.priceCash ?? 0;
    }
    try {
      const machineSlotDocRef = doc(
        db,
        `machines/${machineId}/slots/${slotId}`,
      );

      const actions = [];

      if (slotObj.expiryDate === null || slotObj.expiryDate === "") {
        actions.push(
          updateDoc(machineSlotDocRef, {
            expiryDate: deleteField(),
          }),
        );
        delete slotObj.expiryDate;
      } else if (slotObj.expiryDate !== undefined) {
        // Convert to Firestore Timestamp and assign back
        const expiryDateTimestamp = Timestamp.fromDate(
          slotObj.expiryDate instanceof Date
            ? slotObj.expiryDate
            : slotObj.expiryDate.toDate
              ? slotObj.expiryDate.toDate()
              : new Date(slotObj.expiryDate),
        );
        slotObj.expiryDate = expiryDateTimestamp;
      }

      actions.push(setDoc(machineSlotDocRef, slotObj, { merge: true }));

      await Promise.all(actions);

      toast.success("Element Successfully inserted/updated.");
      navigate(`/machines/edit/${machineId}`);
    } catch (err) {
      console.error("Error handling Firebase operations:", err);
    }
  };

  const onRemove = async () => {
    try {
      const slotDocRef = doc(db, `machines/${machineId}/slots`, slotId);
      await deleteDoc(slotDocRef);

      toast.success("Slot removed successfully.");
      navigate(`/machines/edit/${machineId}`);
    } catch (error) {
      console.error("Error deleting slot:", error);
      toast.error("Failed to remove the slot. Please try again.");
    }
  };

  const handleClearExpiryDate = () => {
    if (!dataToShow) return;

    dataToShow.expiryDate = null;

    setFormKey(Date.now());
  };

  const handleOnChange = (formValues) => {
    const newDirtyFields = {};
    const currentData = dataToShow || {};
    Object.keys(formValues).forEach((key) => {
      if (formValues[key] !== currentData[key]) {
        newDirtyFields[key] = true;
      }
    });
    setDirtyFields(newDirtyFields);
    setModified(Object.keys(newDirtyFields).length > 0);
  };

  const handleMROAccessChange = (updatedValues) => {
    setMROAccess(updatedValues);
  };

  const handleProductRecordChange = (newProductRecord) => {
    setProductRecord(newProductRecord); // Update state in SlotEdit
  };

  const handleProductChange = (value) => {
    setSelectedProductId(value);
  };

  const getAddressByBoardId = async () => {
    try {
      const boardDocRef = doc(db, `machines/${machineId}/boards/${boardId}`);
      const boardDoc = await getDoc(boardDocRef);
      if (boardDoc.exists()) {
        const boardData = boardDoc.data();
        return boardData;
      }
    } catch (error) {
      console.error("Error retrieving board address:", error);
    }
  };

  const expiryDate = dataToShow?.expiryDate?.seconds
    ? dataToShow.expiryDate.seconds * 1000
    : null;
  // Don't render the form until we have the slotId and basic data structure
  // console.log(machineRecord, "machineRecord12345");
  // const handleBeforeProductChange = (formValues, value, newProductRecord) => {
  //   setLockValues({
  //     formValues,
  //     newProductRecord,
  //   });
  //   setSelectedProductId(value);
  // };

  if (!slotId) {
    return (
      <_extendLayout>
        <div className="listMachines">
          <CardHeader title="Loading..." />
        </div>
      </_extendLayout>
    );
  }
  const initialValues = {
    ...dataToShow,
    expiryDate: expiryDate,
    itemNumber: getItemNumber(),
  };
  return (
    <>
      <_extendLayout>
        <div className="listMachines">
          <CardHeader title={`Edit Slot ${slotLabel}`} />
          <CardHeader title="Slot Details" />
          <SimpleForm
            key={formKey}
            toolbar={null}
            initialValues={initialValues}
            onChange={handleOnChange}
            onSubmit={onSubmit}
          >
            <CardContent style={{ width: "100%" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <NumberInput
                    label="Item number (display to user)"
                    source="itemNumber"
                    fullWidth
                    validate={[
                      required("Please enter an item number"),
                      minValue(0, "Please enter at least 0"),
                    ]}
                    defaultValue={getItemNumber()}
                  />
                  <input
                    type="hidden"
                    name="machineSlotId"
                    value={parseInt(slotId)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <NumberInput
                    source="maxCapacity"
                    fullWidth
                    validate={[
                      required("Please enter a max capacity number."),
                      minValue(0, "Please enter at least 0"),
                    ]}
                    defaultValue={dataToShow?.maxCapacity}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <NumberInput
                    label="Current Quantity"
                    source="totalQuantity"
                    fullWidth
                    validate={[
                      required("Please enter a quantity number."),
                      quantityExceedCapacity(
                        "Quantity cannot exceed the max capacity.",
                      ),
                      minValue(0, "Please enter at least 0"),
                    ]}
                    defaultValue={dataToShow?.totalQuantity}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <NumberInput
                    label="Min Capacity"
                    source="minCapacity"
                    fullWidth
                    validate={[
                      quantityExceedCapacity(
                        "Quantity cannot exceed the max capacity.",
                      ),
                      minValue(0, "Please enter at least 0"),
                    ]}
                    defaultValue={dataToShow?.minCapacity}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ flex: 1 }}>
                      <DateInput
                        label="Expiry Date"
                        source="expiryDate"
                        helperText={false}
                        fullWidth
                        defaultValue={
                          expiryDate
                            ? new Date(expiryDate).toISOString().split("T")[0]
                            : undefined
                        }
                        parse={(value) =>
                          value ? Timestamp.fromDate(new Date(value)) : ""
                        }
                        inputProps={{
                          min: new Date().toISOString().split("T")[0],
                        }}
                      />
                      {(() => {
                        const rawDate = expiryDate;
                        let expired = false;

                        if (rawDate) {
                          const expiry = new Date(
                            rawDate.seconds ? rawDate.seconds * 1000 : rawDate,
                          );
                          const today = new Date();
                          expiry.setHours(0, 0, 0, 0);
                          today.setHours(0, 0, 0, 0);
                          expired = expiry < today;
                        }

                        if (expired) {
                          return (
                            <div
                              style={{
                                color: "red",
                                fontSize: "0.75rem",
                                marginTop: "4px",
                              }}
                            >
                              Item is expired
                            </div>
                          );
                        }

                        return null;
                      })()}
                    </div>
                    {expiryDate && (
                      <Grid item xs={12} md={2}>
                        <Tooltip title="Delete Expiry Date">
                          <IconButton onClick={handleClearExpiryDate}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} md={6}></Grid>
                <Grid item xs={12} md={6}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <FormControlLabel
                      label="Drop Sensor"
                      style={{ width: "auto" }}
                      control={
                        <Switch
                          checked={dropSensor}
                          onChange={(e) => setDropSensor(e.target.checked)}
                        />
                      }
                    />
                    <FormControlLabel
                      label="Slot Lock"
                      style={{ width: "auto" }}
                      control={
                        <Switch
                          checked={error}
                          onChange={(e) => setError(e.target.checked)}
                        />
                      }
                    />
                  </div>
                </Grid>
              </Grid>
            </CardContent>

            <CardHeader title="Select Product" />
            <CardContent style={{ width: "100%" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} style={{ width: "100%" }}>
                  {machineRecord?.client?.id && (
                    <ReferenceInput
                      label="Product"
                      source="product.id"
                      reference="products"
                      filterToQuery={(searchText) => ({
                        client: machineRecord.client.id,
                        name: searchText,
                      })}
                      filter={{ client: machineRecord.client.id }}
                      perPage={50}
                      sort={{ field: "name", order: "ASC" }}
                      fullWidth
                    >
                      <AutocompleteInput
                        optionText="name"
                        onChange={(value) => {
                          handleProductChange(value);
                        }}
                        defaultValue={selectedProductId}
                        filterToQuery={(searchText) => ({ name: searchText })}
                        validate={[required("Please select a product")]}
                        fullWidth
                        style={{ width: "100%" }}
                      />
                    </ReferenceInput>
                  )}
                </Grid>
              </Grid>
              {selectedProductId && (
                <FormProvider {...productForm}>
                  <ProductForm
                    productId={selectedProductId}
                    slotId={slotId}
                    machineId={machineId}
                    formValues={dataToShow}
                    dirtyFields={dirtyFields}
                    modified={modified}
                    machineMode={machineRecord?.machineMode}
                    clientId={machineRecord?.client?.id}
                    onMROAccessChange={handleMROAccessChange}
                    onProductRecordChange={handleProductRecordChange}
                    machineRecord={machineRecord}
                  />
                </FormProvider>
              )}
            </CardContent>
            <CardActions style={{ width: "100%" }}>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Box gap={2}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={saving}
                    style={{ marginRight: "1rem" }}
                  >
                    {saving ? "Saving" : "Save"}
                  </Button>
                  <Button
                    onClick={() => navigate(`/machines/edit/${machineId}`)}
                    variant="contained"
                  >
                    Back
                  </Button>
                </Box>
                <Button
                  onClick={onRemove}
                  variant="contained"
                  disabled={removing || saving}
                  style={{ backgroundColor: "red", color: "#FFF" }}
                >
                  Remove
                </Button>
              </Box>
            </CardActions>
          </SimpleForm>
        </div>
      </_extendLayout>
    </>
  );
};

export default SlotItemBoardEdit;
